export default __webpack_public_path__ + "static/media/uploader-abbottNeo-1.28e67b38.png";